var seminars =
webpackJsonp_name_([40,50],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(201);
	__webpack_require__(207);
	__webpack_require__(686);
	__webpack_require__(688);
	__webpack_require__(146);
	__webpack_require__(691);
	__webpack_require__(694);
	__webpack_require__(542);
	__webpack_require__(148);
	__webpack_require__(94);
	__webpack_require__(97);
	__webpack_require__(212);
	__webpack_require__(378);
	__webpack_require__(696);
	__webpack_require__(700);
	
	__webpack_require__(682);
	__webpack_require__(153);
	__webpack_require__(679);
	__webpack_require__(703);

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slickDefaults = __webpack_require__(50);
	__webpack_require__(95);
	
	var size = __webpack_require__(56);
	
	jQuery(function () {
	    $('.js-slick-reviews').each(function () {
	        var $reviewsSlider = $(this);
	
	        $reviewsSlider.slick($.extend({}, slickDefaults.params, slickDefaults.paramsCssAnim, {
	            slidesToShow: 3,
	            adaptiveHeight: false,
	            responsive: [{
	                breakpoint: size.desktop,
	                settings: {
	                    slidesToShow: 2
	                }
	            }, {
	                breakpoint: size.tablet,
	                settings: {
	                    slidesToShow: 1
	                }
	            }]
	        }));
	    });
	});

/***/ }),

/***/ 95:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 97:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 146:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 148:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(154);
	__webpack_require__(156);
	__webpack_require__(157);

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(155);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(48)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!./jquery.loader.css", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!./jquery.loader.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".mx-loader{display:none;position:fixed;z-index:9999;width:100%;height:100%;left:0;top:0;background:hsla(0,0%,100%,.5)}.mx-loader:after{content:\"\";display:block;z-index:9999;position:absolute;margin:auto;top:0;right:0;bottom:0;left:0;background:url(" + __webpack_require__(156) + ") no-repeat 50%;width:64px;height:64px}", ""]);
	
	// exports


/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "plugins/jquery.loader/img/jquery.loader.gif";

/***/ }),

/***/ 157:
/***/ (function(module, exports) {

	'use strict';
	
	(function ($) {
	    var mxLoader = function mxLoader(options) {
	        var self, _init;
	        var $element, $loader;
	        var defaults = {
	            speed: 200,
	            selector: 'body',
	            block: '<div class="mx-loader"></div>',
	            'class': ''
	        };
	
	        if ($.isPlainObject(options)) {
	            defaults = $.extend(true, defaults, options);
	        }
	
	        self = {
	            init: function init() {
	                if (!_init) {
	                    $element = $(defaults.selector);
	                    $loader = $(defaults.block);
	
	                    defaults = $.extend(true, defaults, options);
	                    isString(defaults['class'], true) && $loader.addClass(defaults['class']);
	
	                    _init = true;
	                }
	
	                return _init;
	            },
	
	            show: function show(speed) {
	                if (self.init()) {
	                    speed = self.speed(speed);
	                    $element.append($loader);
	                    $loader.stop(true).fadeIn(speed);
	                }
	            },
	
	            hide: function hide(speed) {
	                if (self.init()) {
	                    speed = self.speed(speed);
	                    $loader.stop(true).fadeOut(speed, function () {
	                        $loader.detach();
	                    });
	                }
	            },
	
	            speed: function speed(_speed) {
	                return $.isNumeric(_speed) ? parseInt(_speed) | 0 : defaults.speed;
	            }
	        };
	
	        return self;
	    };
	
	    /**
	     * Проверка, является ли переменная строкой
	     * Проверка на не пустаую строку
	     */
	
	    var isString = function isString(variable, noEmpty) {
	        var answer = !!(variable === '' || variable && variable.split);
	        if (noEmpty === true) {
	            answer = answer && variable.length > 0;
	        }
	
	        return answer;
	    };
	
	    window.mxLoader = new mxLoader();
	})(jQuery);

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slickDefaults = __webpack_require__(50);
	__webpack_require__(202);
	
	jQuery(function () {
	    $('.js-digest-mini-slider').each(function () {
	        var $this = $(this);
	
	        $this.slick($.extend({}, slickDefaults.params, {
	            slidesToShow: 1
	        }));
	    });
	
	    if ($('#section_descr').html()) {
	        $('.js-scroll-link').removeClass('digest__more-link-hidden');
	    }
	
	    $('.js-digest-video-popup').click(function () {
	        var $this = $(this);
	        var videoType = $this.data('type');
	        var videoSrc = $this.data('src');
	        var sectId = $this.data('id');
	        if (videoType === 'remote') {
	            videoSrc != '' && window.modalSectionVideo && window.modalSectionVideo(videoSrc);
	        } else {
	            (function () {
	                var url = '/ajax/action/catalog_section_digest/get_popup/';
	                var time = new Date().getTime() + 400;
	                window.mxLoader && window.mxLoader.show();
	
	                $.ajax({
	                    url: url,
	                    data: {
	                        id: sectId,
	                        src: videoSrc
	                    },
	                    type: 'post',
	                    success: function success(result) {
	                        // Ограничение минимального времени загрузки формы
	                        time = time - new Date().getTime();
	                        time = time > 0 ? time : 0;
	
	                        setTimeout(function () {
	                            window.mxLoader && window.mxLoader.hide(0);
	                            window.modalSectionVideo(result.html);
	                        }, time);
	                    }
	                });
	            })();
	        }
	    });
	
	    $(window).on('resize', function () {
	        var element = document.querySelector('.jqi--digest-video');
	        if (element) {
	            var $player = undefined,
	                player = undefined,
	                width = undefined,
	                originWidth = undefined,
	                originHeight = undefined;
	            player = element.querySelector('iframe');
	
	            if (player) {
	                $player = $(player);
	                width = $player.width();
	                originWidth = parseInt($player.attr('width')) || parseInt(player.style.width);
	                originHeight = parseInt($player.attr('height')) || parseInt(player.style.height);
	            }
	
	            if (width && width > 0 && originWidth > 0 && originHeight > 0) {
	                var ratio = originWidth / originHeight;
	                var height = width / ratio;
	
	                $player.css({ 'max-height': height + 'px' });
	            }
	        }
	    });
	});
	
	// Метод для вызова всплывающего окна, содержащего iframe видео, размещенного на youtube,
	// либо локальный видеофайл, обернутый в верстку штатного видеоплеера Битрикс
	window.modalSectionVideo = function (source) {
	    window.mxLoader = window.mxLoader || undefined;
	
	    $.prompt(source, {
	        classes: {
	            prompt: 'jqi--width-by-content jqi--digest-video'
	        }
	    });
	
	    $(window).trigger('resize');
	};

/***/ }),

/***/ 202:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 207:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 212:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(60);
	var core = __webpack_require__(62);
	var fails = __webpack_require__(71);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),

/***/ 542:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getPrototypeOf = __webpack_require__(571);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _getOwnPropertyDescriptor = __webpack_require__(574);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);
	
	  if (desc === undefined) {
	    var parent = (0, _getPrototypeOf2.default)(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};

/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(572), __esModule: true };

/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(573);
	module.exports = __webpack_require__(62).Object.getPrototypeOf;


/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(137);
	var $getPrototypeOf = __webpack_require__(245);
	
	__webpack_require__(278)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),

/***/ 574:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(575), __esModule: true };

/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(576);
	var $Object = __webpack_require__(62).Object;
	module.exports = function getOwnPropertyDescriptor(it, key) {
	  return $Object.getOwnPropertyDescriptor(it, key);
	};


/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(79);
	var $getOwnPropertyDescriptor = __webpack_require__(577).f;
	
	__webpack_require__(278)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(136);
	var createDesc = __webpack_require__(74);
	var toIObject = __webpack_require__(79);
	var toPrimitive = __webpack_require__(73);
	var has = __webpack_require__(75);
	var IE8_DOM_DEFINE = __webpack_require__(69);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(70) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(579);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(583);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(586);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(580), __esModule: true };

/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(581);
	module.exports = __webpack_require__(62).Object.setPrototypeOf;


/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(60);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(582).set });


/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(68);
	var anObject = __webpack_require__(67);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(63)(Function.call, __webpack_require__(577).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(584), __esModule: true };

/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(585);
	var $Object = __webpack_require__(62).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(60);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(241) });


/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(587);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(590);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(588), __esModule: true };

/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(235);
	__webpack_require__(256);
	module.exports = __webpack_require__(589).f('iterator');


/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(244);


/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(591), __esModule: true };

/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(592);
	__webpack_require__(255);
	__webpack_require__(599);
	__webpack_require__(600);
	module.exports = __webpack_require__(62).Symbol;


/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(61);
	var has = __webpack_require__(75);
	var DESCRIPTORS = __webpack_require__(70);
	var $export = __webpack_require__(60);
	var redefine = __webpack_require__(238);
	var META = __webpack_require__(593).KEY;
	var $fails = __webpack_require__(71);
	var shared = __webpack_require__(88);
	var setToStringTag = __webpack_require__(243);
	var uid = __webpack_require__(90);
	var wks = __webpack_require__(244);
	var wksExt = __webpack_require__(589);
	var wksDefine = __webpack_require__(594);
	var enumKeys = __webpack_require__(595);
	var isArray = __webpack_require__(596);
	var anObject = __webpack_require__(67);
	var isObject = __webpack_require__(68);
	var toObject = __webpack_require__(137);
	var toIObject = __webpack_require__(79);
	var toPrimitive = __webpack_require__(73);
	var createDesc = __webpack_require__(74);
	var _create = __webpack_require__(241);
	var gOPNExt = __webpack_require__(597);
	var $GOPD = __webpack_require__(577);
	var $GOPS = __webpack_require__(135);
	var $DP = __webpack_require__(66);
	var $keys = __webpack_require__(77);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(598).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(136).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(89)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(65)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(90)('meta');
	var isObject = __webpack_require__(68);
	var has = __webpack_require__(75);
	var setDesc = __webpack_require__(66).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(71)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(61);
	var core = __webpack_require__(62);
	var LIBRARY = __webpack_require__(89);
	var wksExt = __webpack_require__(589);
	var defineProperty = __webpack_require__(66).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(77);
	var gOPS = __webpack_require__(135);
	var pIE = __webpack_require__(136);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(81);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(79);
	var gOPN = __webpack_require__(598).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(78);
	var hiddenKeys = __webpack_require__(91).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),

/***/ 599:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(594)('asyncIterator');


/***/ }),

/***/ 600:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(594)('observable');


/***/ }),

/***/ 679:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var styleSelects = __webpack_require__(303);
	__webpack_require__(680);
	
	$(function () {
	    styleSelects.styleSelects($('.js-styled-select'));
	    window.seminarFormMask && window.seminarFormMask();
	});
	
	/**
	 * Маска ввода для элементов, для которых сохранен data параметр
	 */
	
	window.seminarFormMask = function () {
	    if ($.fn.mask) {
	        $('.web-form input[data-mask*="9"]').each(function () {
	            var $this = $(this);
	            var mask = $this.data('mask');
	            mask && $this.mask(mask);
	        });
	    }
	};
	window.seminarEntryPage = function (seminar, date, city, seminarTime, seminarPlace, isfree) {
	    window.mxLoader = window.mxLoader || undefined;
	    window.common = window.common || undefined;
	
	    var url = '/ajax/component/maximaster:seminars.form/';
	    url += '?seminar=' + seminar + '&date=' + date + '&city=' + city + '&time=' + seminarTime + '&place=' + seminarPlace + '&isfree=' + isfree + '&template=page';
	    var time = new Date().getTime() + 400;
	
	    $.ajax({
	        url: url,
	        success: function success(result) {
	            time = time - new Date().getTime();
	            time = time > 0 ? time : 0;
	
	            var content = $('.formRegistr');
	            var contentFooter = $('.formRegistrFooter');
	
	            content.html(result.html);
	            contentFooter.html(result.html);
	
	            var $select = $('.js-styled-select', content);
	            var $selectFooter = $('.js-styled-select', contentFooter);
	            $select && styleSelects.styleSelects($select);
	            $selectFooter && styleSelects.styleSelects($selectFooter);
	
	            setTimeout(function () {
	
	                window.seminarFormMask && window.seminarFormMask();
	                window.mxLoader && window.mxLoader.hide();
	
	                content.on('click', 'input[type="submit"]', function (event) {
	                    event.preventDefault();
	
	                    var $this = $(this);
	                    var $form = content.find('form');
	
	                    $form.find('.additional-submit').remove();
	                    $form.append('<input class="additional-submit" type="hidden" name="' + this.name + '" value="' + this.value + '" />');
	
	                    time = new Date().getTime() + 400;
	                    window.mxLoader && window.mxLoader.show();
	
	                    $.ajax({
	                        url: url,
	                        data: new FormData($form.get(0)),
	                        processData: false,
	                        contentType: false,
	                        type: 'POST',
	                        success: function success(data) {
	                            time = time - new Date().getTime();
	                            time = time > 0 ? time : 0;
	
	                            setTimeout(function () {
	                                content.html(data.html);
	
	                                var $select = $('.js-styled-select', content);
	                                $select && styleSelects.styleSelects($select);
	
	                                window.seminarFormMask && window.seminarFormMask();
	                                window.mxLoader && window.mxLoader.hide();
	                            }, time);
	                        }
	                    });
	                });
	                contentFooter.on('click', 'input[type="submit"]', function (event) {
	                    event.preventDefault();
	
	                    var $this = $(this);
	                    var $form = contentFooter.find('form');
	
	                    $form.find('.additional-submit').remove();
	                    $form.append('<input class="additional-submit" type="hidden" name="' + this.name + '" value="' + this.value + '" />');
	
	                    time = new Date().getTime() + 400;
	                    window.mxLoader && window.mxLoader.show();
	
	                    $.ajax({
	                        url: url,
	                        data: new FormData($form.get(0)),
	                        processData: false,
	                        contentType: false,
	                        type: 'POST',
	                        success: function success(data) {
	                            time = time - new Date().getTime();
	                            time = time > 0 ? time : 0;
	
	                            setTimeout(function () {
	                                contentFooter.html(data.html);
	
	                                var $selectFooter = $('.js-styled-select', contentFooter);
	                                $selectFooter && styleSelects.styleSelects($selectFooter);
	
	                                window.seminarFormMask && window.seminarFormMask();
	                                window.mxLoader && window.mxLoader.hide();
	                            }, time);
	                        }
	                    });
	                });
	            }, time);
	        }
	    });
	};
	/**
	 * Всплывашка с веб формой записи на семинар
	 * @param seminar
	 * @param date
	 * @param city
	 */
	
	window.seminarEntry = function (seminar, date, city, seminarTime, seminarPlace, isfree) {
	    window.mxLoader = window.mxLoader || undefined;
	    window.common = window.common || undefined;
	
	    var url = '/ajax/component/maximaster:seminars.form/';
	    url += '?seminar=' + seminar + '&date=' + date + '&city=' + city + '&time=' + seminarTime + '&place=' + seminarPlace + '&isfree=' + isfree;
	
	    var options = {
	        classes: {
	            prompt: 'web-form-popup',
	            message: 'web-form-content'
	        }
	    };
	
	    // Ограничение по времени загрузки формы, прелоадер
	    var time = new Date().getTime() + 400;
	    window.mxLoader && window.mxLoader.show();
	    $.ajax({
	        url: url,
	        success: function success(result) {
	            time = time - new Date().getTime();
	            time = time > 0 ? time : 0;
	
	            setTimeout(function () {
	                var $modal = $.prompt(result.html, options);
	                var $content = $('.web-form-content', $modal);
	
	                window.seminarFormMask && window.seminarFormMask();
	                window.mxLoader && window.mxLoader.hide();
	
	                // Костыль связанный с тем, что в ff FormData не понимает, на какую кнопку мы нажали
	                $content.on('click', 'input[type="submit"]', function (event) {
	                    event.preventDefault();
	
	                    var $this = $(this);
	                    var $form = $this.closest('form');
	
	                    $form.find('.additional-submit').remove();
	                    $form.append('<input class="additional-submit" type="hidden" name="' + this.name + '" value="' + this.value + '" />');
	
	                    time = new Date().getTime() + 400;
	                    window.mxLoader && window.mxLoader.show();
	
	                    $('body, html').animate({ scrollTop: $content.offset().top - 15 }, 400);
	
	                    $.ajax({
	                        url: url,
	                        data: new FormData($form.get(0)),
	                        processData: false,
	                        contentType: false,
	                        type: 'POST',
	                        success: function success(data) {
	                            time = time - new Date().getTime();
	                            time = time > 0 ? time : 0;
	
	                            setTimeout(function () {
	                                $content.html(data.html);
	
	                                var $select = $('.js-styled-select', $content);
	                                $select && styleSelects.styleSelects($select);
	
	                                window.seminarFormMask && window.seminarFormMask();
	                                window.mxLoader && window.mxLoader.hide();
	                            }, time);
	                        }
	                    });
	                });
	            }, time);
	        }
	    });
	};
	
	window.seminarConsultationEntry = function (seminar, date, city, seminarTime, seminarPlace, isfree) {
	    window.mxLoader = window.mxLoader || undefined;
	    window.common = window.common || undefined;
	
	    var url = '/ajax/component/maximaster:seminars.form.consultation/';
	    url += '?seminar=' + seminar + '&date=' + date + '&city=' + city + '&time=' + seminarTime + '&place=' + seminarPlace + '&isfree=' + isfree;
	
	    var options = {
	        classes: {
	            prompt: 'web-form-popup',
	            message: 'web-form-content'
	        }
	    };
	
	    // Ограничение по времени загрузки формы, прелоадер
	    var time = new Date().getTime() + 400;
	    window.mxLoader && window.mxLoader.show();
	    $.ajax({
	        url: url,
	        success: function success(result) {
	            time = time - new Date().getTime();
	            time = time > 0 ? time : 0;
	
	            setTimeout(function () {
	                var $modal = $.prompt(result.html, options);
	                var $content = $('.web-form-content', $modal);
	
	                window.seminarFormMask && window.seminarFormMask();
	                window.mxLoader && window.mxLoader.hide();
	
	                // Костыль связанный с тем, что в ff FormData не понимает, на какую кнопку мы нажали
	                $content.on('click', 'input[type="submit"]', function (event) {
	                    event.preventDefault();
	
	                    var $this = $(this);
	                    var $form = $this.closest('form');
	
	                    $form.find('.additional-submit').remove();
	                    $form.append('<input class="additional-submit" type="hidden" name="' + this.name + '" value="' + this.value + '" />');
	
	                    time = new Date().getTime() + 400;
	                    window.mxLoader && window.mxLoader.show();
	
	                    $('body, html').animate({ scrollTop: $content.offset().top - 15 }, 400);
	
	                    $.ajax({
	                        url: url,
	                        data: new FormData($form.get(0)),
	                        processData: false,
	                        contentType: false,
	                        type: 'POST',
	                        success: function success(data) {
	                            time = time - new Date().getTime();
	                            time = time > 0 ? time : 0;
	
	                            setTimeout(function () {
	                                $content.html(data.html);
	
	                                var $select = $('.js-styled-select', $content);
	                                $select && styleSelects.styleSelects($select);
	
	                                window.seminarFormMask && window.seminarFormMask();
	                                window.mxLoader && window.mxLoader.hide();
	                            }, time);
	                        }
	                    });
	                });
	            }, time);
	        }
	    });
	};

/***/ }),

/***/ 680:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var styleSelects = __webpack_require__(303);
	__webpack_require__(683);
	
	$(function () {
	    styleSelects.styleSelects($('.js-styled-select'));
	
	    /**
	     * Обработка Ajax перезагрузки компонента семинаров
	     * @param element
	     */
	
	    var ajaxComponent = function ajaxComponent(element) {
	        window.mxLoader = window.mxLoader || undefined;
	
	        var $this = $(element);
	        var $container = $this.closest('.js-ajax-component');
	
	        if ($container.length === 1) {
	            var url = $container.data('ajax--url');
	            var data = $container.data('ajax--parameters');
	
	            if (!url) {
	                return;
	            }
	
	            !$.isPlainObject(data) && (data = {});
	
	            if ($this.is('input') || $this.is('select')) {
	                data[element.name] = element.value;
	                /**
	                 * Если взаимодействие происходит не с постраничной навигацией, номер страницы не должен быть задан в параметрах запроса.
	                 * Это сделано во избежание ошибки, при которой установленный фильтр позволяет отобразить меньше страниц,
	                 * чем номер страницы, открытой в данный момент. Эта проблема приводила к ошибке "нет данных", когда
	                 * скрипт пытался отобразить, например, 3-ю страницу из двух возможных
	                 */
	                delete data['page'];
	            } else if ($this.hasClass('pagination__item')) {
	                if ($this.hasClass('pagination__item--current')) {
	                    return;
	                }
	
	                var href = $this.attr('href');
	                var matches = href && href.match ? href.match(/page=([\d]+)/) : [];
	                var page = matches ? parseInt(matches[1]) | 0 || 1 : 1;
	                data['page'] = page;
	            }
	
	            var time = new Date().getTime() + 500;
	            $('body, html').animate({ scrollTop: $container.offset().top - 15 }, 400);
	            window.mxLoader && window.mxLoader.show();
	
	            $.ajax({
	                url: url,
	                data: data,
	                type: 'get',
	                success: function success(result) {
	                    if (result && result.html) {
	                        time = time - new Date().getTime();
	                        time = time > 0 ? time : 0;
	
	                        var $html = $(result.html);
	
	                        var $block;
	                        var $select;
	
	                        $html.each(function () {
	                            $block = $(this);
	                            if ($block.hasClass('js-ajax-component')) {
	                                var get = $block.data('ajax--get');
	                                $select = $('.js-styled-select', $block);
	
	                                var parameters = $block.data('ajax--parameters');
	                                if (parameters && parameters['SET_URL'] === 'Y') {
	                                    history && history.pushState && history.pushState(null, '', get ? '?' + get : window.location.pathname);
	                                }
	
	                                $select && styleSelects.styleSelects($select);
	                                return false;
	                            }
	                        });
	
	                        setTimeout(function () {
	                            $container.replaceWith($html);
	                            window.mxLoader && window.mxLoader.hide();
	                        }, time);
	                    }
	                }
	            });
	        }
	    };
	
	    // Обработка при изменении значения фильтра или количества элементов
	    $(document).on('change', '.js-ajax-component input, .js-ajax-component select', function () {
	        ajaxComponent(this);
	        /* Если меняем значение города в фильтре */
	        if ($(this).attr('name') === 'city') {
	            /* запрос на получение seo-текста */
	            $.ajax({
	                url: '/ajax/action/page:seminars_list/getSeoTextByLocationCode/?city=' + $(this).val(),
	                type: 'get',
	                success: function success(result) {
	                    if (result.code === 200) {
	                        $('.js-seminar-seo-text-container').html(result.data['SEO_TEXT_PREVIEW']);
	                        $('.js-seminar-seo-text-full-container').html(result.data['SEO_TEXT']);
	                    }
	                }
	            });
	        }
	    });
	
	    // Обработка при клике на элемент постраничной навигации
	    $(document).on('click', '.js-ajax-component .pagination__item', function (event) {
	        if ($(this).hasClass('pagination__item--inactive')) {
	            return;
	        }
	        event.preventDefault();
	        ajaxComponent(this);
	    });
	
	    // Обработка при клике на кнопку записи на семинар
	    $(document).on('click', '.js-seminar-entry', function (event) {
	        var $this = $(this);
	        if ($this.attr('href')) {
	            return;
	        }
	
	        event.preventDefault();
	
	        // Если не установлен адрес перехода по ссылке семинара, то отображаем форму записи на семинар
	        if (!window.seminarEntry) {
	            throw new Error('Ошибка вызова окна записи на семинар. На странице не подключен метод "seminarEntry".');
	        }
	
	        var seminar = parseInt($this.data('seminar')) | 0;
	        if (seminar) {
	            window.seminarEntry(seminar, $this.data('date'), $this.data('city'), $this.data('time'), $this.data('place'), $this.data('isfree'));
	        }
	    });
	});

/***/ }),

/***/ 683:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 686:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(109)['default'];
	
	var _classCallCheck = __webpack_require__(114)['default'];
	
	__webpack_require__(689);
	var size = __webpack_require__(56);
	
	var BigLink = (function () {
	    function BigLink(element) {
	        _classCallCheck(this, BigLink);
	
	        this.bigLinkList = element;
	        this.checkScroll();
	        this.setEvents();
	    }
	
	    _createClass(BigLink, [{
	        key: 'deleteBigLinkScroll',
	        value: function deleteBigLinkScroll() {
	            var bigLinkListStyle = window.getComputedStyle(this.bigLinkList);
	            var bigLinkListPaddingRight = this.bigLinkList.offsetWidth - this.bigLinkList.clientWidth;
	            var bigLinkListMarginRight = parseInt(bigLinkListStyle.getPropertyValue('margin-right'), 10);
	            this.bigLinkList.style.paddingRight = bigLinkListPaddingRight + 'px';
	            this.bigLinkList.style.width = 'calc(100% + ' + (bigLinkListPaddingRight - bigLinkListMarginRight) + 'px)';
	        }
	    }, {
	        key: 'checkScroll',
	        value: function checkScroll() {
	            if (window.innerWidth < size.tablet) {
	                this.deleteBigLinkScroll();
	            } else {
	                this.bigLinkList.setAttribute('style', '');
	            }
	        }
	    }, {
	        key: 'setEvents',
	        value: function setEvents() {
	            var _this = this;
	
	            $(window).resize(function () {
	                _this.checkScroll();
	            });
	        }
	    }]);
	
	    return BigLink;
	})();
	
	$(window).load(function () {
	    var bigLinkList = document.querySelector('.big-link__list');
	    if (bigLinkList !== null) {
	        new BigLink(bigLinkList);
	    }
	});

/***/ }),

/***/ 689:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(692);
	
	jQuery(function () {
	    $('.js-btn-mini-filter').click(function (e) {
	        e.preventDefault();
	        var $this = $(this).addClass('mini-filter__btn--hidden');
	        var $miniFilter = $this.closest('.mini-filter');
	        $miniFilter.find('.mini-filter__content').addClass('mini-filter__content--visible');
	    });
	});

/***/ }),

/***/ 692:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 694:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(570)['default'];
	
	var _inherits = __webpack_require__(578)['default'];
	
	var _createClass = __webpack_require__(109)['default'];
	
	var _classCallCheck = __webpack_require__(114)['default'];
	
	var _interopRequireDefault = __webpack_require__(116)['default'];
	
	var _modulesSlider = __webpack_require__(697);
	
	var _modulesSlider2 = _interopRequireDefault(_modulesSlider);
	
	__webpack_require__(698);
	
	var TeacherSlider = (function (_AbstractSlider) {
	    _inherits(TeacherSlider, _AbstractSlider);
	
	    function TeacherSlider() {
	        _classCallCheck(this, TeacherSlider);
	
	        _get(Object.getPrototypeOf(TeacherSlider.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(TeacherSlider, [{
	        key: 'mobileOptions',
	        get: function get() {
	            return {
	                slidesToShow: 1,
	                dots: false,
	                arrow: true
	            };
	        }
	    }, {
	        key: 'mobileBigOptions',
	        get: function get() {
	            return {
	                slidesToShow: 2,
	                dots: false,
	                arrow: true
	            };
	        }
	    }, {
	        key: 'tabletOptions',
	        get: function get() {
	            return {
	                slidesToShow: 3,
	                dots: false,
	                arrow: true
	            };
	        }
	    }, {
	        key: 'desktopOptions',
	        get: function get() {
	            return {
	                slidesToShow: 4,
	                dots: false,
	                arrow: true
	            };
	        }
	    }]);
	
	    return TeacherSlider;
	})(_modulesSlider2['default']);
	
	$(window).load(function () {
	    var teacherElement = $('.js-slick-teachers-list');
	    if (teacherElement.length !== 0) {
	        new TeacherSlider(teacherElement);
	    }
	});

/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(109)['default'];
	
	var _classCallCheck = __webpack_require__(114)['default'];
	
	var _interopRequireDefault = __webpack_require__(116)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _modulesSize = __webpack_require__(56);
	
	var _modulesSize2 = _interopRequireDefault(_modulesSize);
	
	var _modulesDebounce = __webpack_require__(53);
	
	var _modulesDebounce2 = _interopRequireDefault(_modulesDebounce);
	
	var AbstractSlider = (function () {
	    function AbstractSlider(element) {
	        _classCallCheck(this, AbstractSlider);
	
	        this.$sldier = element;
	        this.states = {
	            desktop: {
	                name: 'desktop',
	                options: this.desktopOptions,
	                min: _modulesSize2['default'].desktop,
	                max: Infinity
	            },
	            tabletBig: {
	                name: 'tabletBig',
	                options: this.tabletBigOptions,
	                min: _modulesSize2['default'].tabletBig,
	                max: _modulesSize2['default'].desktop
	            },
	            tablet: {
	                name: 'tablet',
	                options: this.tabletOptions,
	                min: _modulesSize2['default'].tablet,
	                max: _modulesSize2['default'].tabletBig
	            },
	            mobileBig: {
	                name: 'mobileBig',
	                options: this.mobileBigOptions,
	                min: _modulesSize2['default'].mobileBig,
	                max: _modulesSize2['default'].tablet
	            },
	            mobile: {
	                name: 'mobile',
	                options: this.mobileOptions,
	                min: 0,
	                max: _modulesSize2['default'].mobileBig
	            }
	        };
	        this.lastState = false;
	        this.initSlider();
	        this.initDebounce();
	    }
	
	    _createClass(AbstractSlider, [{
	        key: 'destroy',
	        value: function destroy() {
	            this.$sldier.slick('unslick');
	        }
	    }, {
	        key: 'checkInit',
	        value: function checkInit() {
	            return this.$sldier.hasClass('slick-initialized');
	        }
	    }, {
	        key: 'setLastState',
	        value: function setLastState() {
	            this.lastState = this.state.name;
	        }
	    }, {
	        key: 'initSlider',
	        value: function initSlider() {
	            if (this.state.options !== false) {
	                this.$sldier.slick(this.state.options);
	            }
	            this.setLastState();
	        }
	    }, {
	        key: 'reRenderSlider',
	        value: function reRenderSlider() {
	            if (!this.isChangeState) {
	                return;
	            }
	            if (this.checkInit()) {
	                this.destroy();
	            }
	            this.initSlider();
	        }
	    }, {
	        key: 'initDebounce',
	        value: function initDebounce() {
	            var _this = this;
	
	            _modulesDebounce2['default'].setResizeDebounce(function () {
	                _this.reRenderSlider();
	            });
	        }
	    }, {
	        key: 'isChangeState',
	        get: function get() {
	            return this.state.name !== this.lastState;
	        }
	    }, {
	        key: 'mobileOptions',
	        get: function get() {
	            return false;
	        }
	    }, {
	        key: 'mobileBigOptions',
	        get: function get() {
	            return this.mobileOptions;
	        }
	    }, {
	        key: 'tabletOptions',
	        get: function get() {
	            return false;
	        }
	    }, {
	        key: 'tabletBigOptions',
	        get: function get() {
	            return this.tabletOptions;
	        }
	    }, {
	        key: 'desktopOptions',
	        get: function get() {
	            return false;
	        }
	    }, {
	        key: 'state',
	        get: function get() {
	            for (var key in this.states) {
	                if (window.innerWidth >= this.states[key].min && window.innerWidth < this.states[key].max) {
	                    return this.states[key];
	                }
	            }
	        }
	    }]);
	
	    return AbstractSlider;
	})();
	
	exports['default'] = AbstractSlider;
	module.exports = exports['default'];

/***/ }),

/***/ 698:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(570)['default'];
	
	var _inherits = __webpack_require__(578)['default'];
	
	var _createClass = __webpack_require__(109)['default'];
	
	var _classCallCheck = __webpack_require__(114)['default'];
	
	var _interopRequireDefault = __webpack_require__(116)['default'];
	
	var _modulesSlider = __webpack_require__(697);
	
	var _modulesSlider2 = _interopRequireDefault(_modulesSlider);
	
	__webpack_require__(701);
	
	var SpecSlider = (function (_AbstractSlider) {
	    _inherits(SpecSlider, _AbstractSlider);
	
	    function SpecSlider() {
	        _classCallCheck(this, SpecSlider);
	
	        _get(Object.getPrototypeOf(SpecSlider.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(SpecSlider, [{
	        key: 'mobileBigOptions',
	        get: function get() {
	            return {
	                slidesToShow: 2,
	                dots: false,
	                arrow: true
	            };
	        }
	    }, {
	        key: 'tabletOptions',
	        get: function get() {
	            return {
	                slidesToShow: 3,
	                dots: false,
	                arrow: true
	            };
	        }
	    }]);
	
	    return SpecSlider;
	})(_modulesSlider2['default']);
	
	$(window).load(function () {
	    var specElement = $('.js-slick-specials-list');
	    if (specElement.length !== 0) {
	        new SpecSlider(specElement);
	    }
	});

/***/ }),

/***/ 701:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(704);
	
	$(function () {
	    /**
	     * При клике не элемент с видео получаем id элемента и делаем запрос
	     * на получение контента для всплывашки с ее последующим отображением
	     */
	
	    $(document).on('click', '.js-modal-article-video', function (event) {
	        event.preventDefault();
	
	        var $this = $(this);
	        var id = parseInt($this.data('id')) | 0;
	
	        id > 0 && window.modalArticleVideo && window.modalArticleVideo(id);
	    });
	
	    /**
	     * Пропорциональный ресайз видео проигрывателя
	     */
	
	    $(window).on('resize', function () {
	        var element = document.querySelector('.jqi--article-video');
	        if (element) {
	            var $player, player, width, originWidth, originHeight;
	            player = element.querySelector('iframe');
	
	            // Ресайз битриксового плеера происходит не корректно, убираем
	            //!player && (player = element.querySelector('div[id^="bx_flv_player"]'));
	
	            if (player) {
	                $player = $(player);
	                width = $player.width();
	                originWidth = parseInt($player.attr('width')) || parseInt(player.style.width);
	                originHeight = parseInt($player.attr('height')) || parseInt(player.style.height);
	            }
	
	            if (width && width > 0 && originWidth > 0 && originHeight > 0) {
	                var ratio = originWidth / originHeight;
	                var height = width / ratio;
	
	                $player.css({ 'max-height': height + 'px' });
	            }
	        }
	    });
	});
	
	/**
	 * Получаем через аякс контент всплывашки
	 * и показываем всплывающее окно с видео плеером
	 * @param id
	 */
	
	window.modalArticleVideo = function (id) {
	    window.mxLoader = window.mxLoader || undefined;
	
	    var url = '/ajax/component/maximaster:seminars.video/modal/?ID=' + id;
	
	    // Ограничение минимального времени загрузки формы, прелоадер
	    // Плохо выглядит, когда прелоадер очень быстро мелькает
	    var time = new Date().getTime() + 400;
	    window.mxLoader && window.mxLoader.show();
	
	    $.ajax({
	        url: url,
	        success: function success(result) {
	            // Ограничение минимального времени загрузки формы
	            time = time - new Date().getTime();
	            time = time > 0 ? time : 0;
	
	            setTimeout(function () {
	                window.mxLoader && window.mxLoader.hide(0);
	                $.prompt(result.html, {
	                    classes: {
	                        prompt: 'jqi--width-by-content jqi--article-video'
	                    }
	                });
	
	                $(window).trigger('resize');
	            }, time);
	        }
	    });
	};

/***/ }),

/***/ 704:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// js/seminars.57b4da31e29b9edf9ded.js